import React from 'react';

import { Button, Image } from '@chakra-ui/react';

import * as images from '../images';
import { TopPageVariant } from './types';

type PropsType = React.HTMLProps<HTMLButtonElement> & {
  variant: TopPageVariant;
};

const buttonImages = {
  normal: images.signupButton,
  intern: images.signupButtonYellow,
  interview: images.signupButton,
};

const SignUpButton: React.FC<PropsType> = ({ variant, onClick }) => (
  <Button variant="link" onClick={onClick}>
    <Image src={buttonImages[variant]} alt="登録" width="322px" />
  </Button>
);

export default SignUpButton;
